/* eslint-disable react/prop-types */
import './index.scss';
import ModalBase from '.';
import { ModalProps } from '../../types';
import { useEffect, useState } from 'react';
import { Alert, Button, Input, Select } from '@piggytechng/component-library';
import { OverideButtonStyle, OverideInputStyle, OverideSelectStyle } from '../../helpers/utils';
import useRolePermissions from '../../hooks/useRolePermissions';
import { authPayload } from '../../helpers/utils/auth-payload';
// useSelector and RootState no longer needed here
import ModalExecuteAction from './ModalExecuteAction';

function ModalAdminAction({ modalIsOpen, setIsOpen, data, action, type }: ModalProps) {
  const [showActionModal, setShowActionModal] = useState(false);

  const { roles, isLoading, inviteAdmin, editAdmin } = useRolePermissions({});

  const SelectStyle = { ...OverideSelectStyle, style: { ...OverideSelectStyle.style, zIndex: undefined } };

  function closeModal() {
    if (isLoading) return;
    setIsOpen(false);
  }

  const [form, setForm] = useState({
    email: '',
    role: '',
  });

  const proceed = (e: React.FormEvent) => {
    e.preventDefault();

    if (!form.email || !form.role) {
      Alert.error('Please fill all fields to proceed');
      return;
    }

    setShowActionModal(true);
    setIsOpen(false);
    return;
  };

  const handleSubmit = (password: string) => {
    let payload;

    if (type === 'invite') {
      payload = {
        email: form.email,
        roleId: form.role,
        ...authPayload(password),
      };

      inviteAdmin(payload).finally(() => {
        setShowActionModal(false);
        setIsOpen(false);
        action && action();
      });
    } else if (type === 'edit') {
      if (data?.roleId === form.role) {
        Alert.error('No changes made to be saved');
        return;
      }

      payload = {
        userId: data?.userId,
        roleId: form.role,
      };

      editAdmin(payload).finally(() => {
        setShowActionModal(false);
        setIsOpen(false);
        action && action();
      });
    }
  };

  useEffect(() => {
    if (modalIsOpen) {
      setForm({
        email: data?.email || '',
        role: data?.roleId || '',
      });
    }
  }, [modalIsOpen]);

  return (
    <>
      <ModalBase modalIsOpen={modalIsOpen} setIsOpen={setIsOpen}>
        <div className={`modal-processor`}>
          <div className="modal-processor__header">
            <h2>{type === 'invite' ? 'Invite' : type === 'edit' ? 'Edit' : ''} Admin</h2>
            <button onClick={closeModal}>&times;</button>
          </div>

          <form className="modal-processor__body" onSubmit={proceed}>
            {data && data.firstname && (
              <Input
                {...OverideInputStyle}
                labelStyle={{
                  color: '#666766',
                }}
                label="Full Name"
                value={`${data.firstname} ${data.lastname}`}
                disabled
              />
            )}

            <Input
              {...OverideInputStyle}
              labelStyle={{
                color: '#666766',
              }}
              label="Email Address"
              value={form.email}
              disabled={type === 'edit'}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
            />

            <Select
              {...SelectStyle}
              labelStyle={{ color: '#666766' }}
              options={roles}
              backgroundColor="#F9FAFB"
              outlineColor="none"
              label=" Role"
              placeholder="Select role"
              value={form.role}
              onChange={(e) => setForm({ ...form, role: e })}
            />

            <div className="modal-processor__actions">
              <Button {...OverideButtonStyle} className="modal-processor__actions-resolve" type="submit">
                {type === 'invite' ? 'Invite' : 'Save Changes'}
              </Button>
            </div>
          </form>
        </div>
      </ModalBase>

      <ModalExecuteAction
        modalIsOpen={showActionModal}
        isLoading={isLoading.isInvitingAdmin || isLoading.isEditingAdmin}
        setIsOpen={setShowActionModal}
        text={type === 'invite' ? 'invite this account?' : 'edit this account?'}
        action={(password: string) => handleSubmit(password)}
        actionColor="#1734CA"
        buttonText={type === 'invite' ? 'Invite' : 'Save Changes'}
      />
    </>
  );
}

export default ModalAdminAction;
